/**
 * Color tokens aligned with Ant Design's color system
 *
 * Entity-specific surface colors follow the app's data model:
 * Property (blue) → Building (green) → Unit (purple)
 */
export const colors = {
  // ============================================
  // BRAND & ACTIONS
  // ============================================

  /** Primary buttons, links, active states */
  actionPrimary: "#1890ff",

  /** Secondary actions, accents (e.g., App Guide button) */
  actionSecondary: "#722ed1",

  /** Tertiary actions, organizations, team-related (teal) */
  actionTertiary: "#13c2c2",

  // ============================================
  // STATUS INDICATORS
  // ============================================

  /** Success messages, "Occupied" status, positive values */
  statusSuccess: "#52c41a",

  /** Warnings, "Renovation" status, attention needed */
  statusWarning: "#faad14",

  /** Errors, negative values, destructive actions */
  statusError: "#cf1322",

  /** Informational highlights (same as primary for consistency) */
  statusInfo: "#1890ff",

  // ============================================
  // TEXT HIERARCHY
  // ============================================

  /** Main content, headings */
  textPrimary: "inherit",

  /** Descriptions, secondary info, labels */
  textSecondary: "#666666",

  /** Placeholders, disabled text, hints */
  textMuted: "#999999",

  /** Text on dark/colored backgrounds */
  textInverse: "#ffffff",

  // ============================================
  // BACKGROUNDS / SURFACES
  // ============================================

  /** Main content areas */
  surfaceDefault: "#ffffff",

  /** Sidebars, secondary panels */
  surfaceSubtle: "#fafafa",

  /** Grouped sections, alternate rows */
  surfaceMuted: "#f5f5f5",

  /** Property-related highlights (blue tint) */
  surfaceProperty: "#f0f7ff",

  /** Building-related highlights (green tint) */
  surfaceBuilding: "#f6ffed",

  /** Unit-related highlights (purple tint) */
  surfaceUnit: "#f9f0ff",

  // ============================================
  // BORDERS & DIVIDERS
  // ============================================

  /** Light dividers, card borders */
  borderSubtle: "#f0f0f0",

  /** Standard borders, disabled states */
  borderDefault: "#e8e8e8",
} as const;

export type ColorToken = keyof typeof colors;
